<template>
    <el-dialog v-model="visible" title="充值金额" width="500px" append-to-body :close-on-click-modal="false">
        <el-form ref="formRef" :model="form" label-width="100px" style="margin-top: 10px">
            <el-input v-model="form.id" type="hidden" />

            <el-form-item label="重置金额" prop="amount" required>
                <el-input-number v-model="form.amount" :min="0" :precision="2" placeholder="请输入重置金额" style="width: 100%" />
            </el-form-item>
        </el-form>

        <template #footer>
            <div class="text-right">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="danger" @click="submit">确认</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { recharge } from '@/api/building'

const visible = ref(false)
const formRef = ref(null)

const form = reactive({
    id: '',
    amount: 0
})

const emit = defineEmits(['success'])

// 打开弹窗
function open(row = {}) {
    visible.value = true
    form.id = row.id || ''
    form.amount = 0
}

// 提交 —— 自动 ×100
async function submit() {
    if (form.amount < 0) {
        ElMessage.warning('金额不能小于0')
        return
    }

    const submitData = {
        id: form.id,
        amount: Math.round(form.amount * 100)
    }

    // 提交
    await recharge(submitData)
    emit('success', submitData)
    ElMessage.success('充值成功')
    visible.value = false
}

defineExpose({ open })
</script>

<style scoped>
.text-right {
    text-align: right;
}
</style>
